import React from "react";
import DashboardGrid from "./DashboardGrid";
const Dashboard: React.FC = () => {
  return (
    <>
      <DashboardGrid />
    </>
  );
};

export default Dashboard;
